// extracted by mini-css-extract-plugin
export default {"closeIcon":"CustomAutoComplete_closeIcon__YvvtF"};